import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import GridLayout from '../../../../components/common/GridLayout';
import IconButton from '../../../../components/common/IconButton';
import { useActiveStateSelector } from '../../../../containers/customizer.duck';
import { IS_TAB } from '../../../../utils/common';
import Carousel from '../../../../components/common/Carousel';
import useCarouselItemConfig from '../../../../hooks/useCarouselItemConfig';

const Finish = ({
  options,
  initialSelectedCustomizationIndex,
  updatePartsConfig,
  partsConfig,
  selectedPart
}) => {
  // const [activeFinish, setActiveFinish] = useState(
  //   initialSelectedCustomizationIndex
  // );

  // useActiveStateSelector('finish', options, partsConfig, setActiveFinish);
  // useEffect(() => {
  //   setActiveFinish(initialSelectedCustomizationIndex);
  // }, [initialSelectedCustomizationIndex]);

  const { ref: cardRef, width: cardWidth } = useCarouselItemConfig();

  return (
    <div className="finish">
      {IS_TAB ? (
        <Carousel noOfItems={options && options.length} itemWidth={cardWidth}>
          {options.map((option, i) => (
            <div className="finish-item" key={option.id} ref={cardRef}>
              <IconButton
                backgroundColor={
                  selectedPart === option.partId ? '#000' : '#c4c4c4'
                }
                iconColor={selectedPart === option.partId ? '#fff' : '#000'}
                buttonTextStyle={
                  selectedPart === option.partId ? { fontWeight: 'bold' } : null
                }
                icon={option.configData.icon}
                label={option.configData.label}
                isBackgroundImage
                onClick={() => {
                  // setActiveFinish(i);
                  updatePartsConfig(options[i]);
                }}
              />
            </div>
          ))}
        </Carousel>
      ) : (
        <GridLayout columns={2} alignCenter>
          {options.map((option, i) => (
            <div className="finish-item" key={option.id}>
              <IconButton
                backgroundColor={
                  selectedPart === option.partId ? '#000' : '#c4c4c4'
                }
                iconColor={selectedPart === option.partId ? '#fff' : '#000'}
                buttonTextStyle={
                  selectedPart === option.partId ? { fontWeight: 'bold' } : null
                }
                icon={option.configData.icon}
                label={option.configData.label}
                isBackgroundImage
                onClick={() => {
                  // setActiveFinish(i);
                  updatePartsConfig(options[i]);
                }}
              />
            </div>
          ))}
        </GridLayout>
      )}
    </div>
  );
};

Finish.propTypes = {
  options: PropTypes.array,
  initialSelectedCustomizationIndex: PropTypes.number,
  updatePartsConfig: PropTypes.func,
  setActiveVisorColor: PropTypes.func,
  partsConfig: PropTypes.object
};

export default Finish;
